import { useEffect, useRef } from "react";
import { useFloatingBubbles } from "../../../context/floating-bubbles/FloatingBubblesContext";
import { useInternalWebRTC } from "../_context/InternalWebRTCContext";

export const InternalWebRTCCallSideEffects = () => {
  const { internalCallView, incomingCall, activeCall } = useInternalWebRTC();
  const { openCalls } = useFloatingBubbles();
  const openedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!internalCallView) {
      openedKeyRef.current = null;
      return;
    }

    const callUid = incomingCall?.callUid ?? activeCall?.callUid ?? "unknown";
    const openKey = `${internalCallView}:${callUid}`;

    if (openedKeyRef.current === openKey) return;

    openedKeyRef.current = openKey;
    openCalls();
  }, [internalCallView, incomingCall?.callUid, activeCall?.callUid, openCalls]);

  return null;
};
